import type { NavigationGuardNext, RouteLocationNormalized, Router } from 'vue-router'
import { handleRouteChange } from './router-logic'
import { useNavigationStore } from '@/stores/portal-stores/component-stores/navigation'
import { setupBeforeEach } from './beforeEach-logic'
import { setupAfterEach } from './afterEach-logic'

export function setupRouterGuards(router: Router, isOnboarding: boolean) {
  router.beforeResolve(
    async (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      const navigationStore = useNavigationStore()
      navigationStore.setIsNavigating(true)

      if (isOnboarding === true) {
        await handleOnboarding(to, from, next)
      } else {
        await handleRouteChange(to, from, next)
      }
    }
  )

  setupAfterEach(router)
  setupBeforeEach(router)
}

export const handleOnboarding = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  console.log('ROUTER FIRST LINE: to.name = ', to, to.fullPath, to, from, next)
  next()
}
